import { useEffect, useRef, useState } from 'react'
import { loadKakaoMapSdk } from '@/shared/lib/kakaoMapSdk'

const DEFAULT_BOX = 'mt-2 h-40 overflow-hidden rounded-[10px] border border-white-400'

export function KakaoPointMap({
  lat,
  lng,
  className = DEFAULT_BOX,
}: {
  lat: number
  lng: number
  className?: string
}) {
  const box = useRef<HTMLDivElement>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true

    loadKakaoMapSdk()
      .then((maps) => {
        if (!alive || box.current === null) return
        const center = new maps.LatLng(lat, lng)
        const map = new maps.Map(box.current, { center, level: 4, draggable: false })
        new maps.Marker({ position: center }).setMap(map)
      })
      .catch(() => {
        if (alive) setFailed(true)
      })

    return () => {
      alive = false
    }
  }, [lat, lng])

  // 지도를 못 그리면 자리도 만들지 않는다 — 주소 자체는 위에 글자로 이미 보인다.
  if (failed) return null

  return <div ref={box} className={className} aria-hidden="true" />
}
